import { GameMode, GameModeStringMap } from '../enums';

export const isSameMode = (currentMode: GameMode, target: GameMode | 'real' | 'fun'): boolean => {
  const isTargetNumber = !Number.isNaN(+target);
  const targetMode: GameMode  = isTargetNumber ? +target : GameModeStringMap[target as 'real' | 'fun'];
  return currentMode === targetMode;
};
